<script>
    import { onMount } from 'svelte';
    import { appSettings } from "../stores";

    const partners = [
        'logo_agf.jpg',
        'filmedien_rlp.jpg',
        'freytag_petersen.jpg',
        'reh-stiftung.jpg',
        'klf_autoservice.jpg',
        'lpb_rlp.jpg',
        'LAG.jpg',
        'landtag_rlp.jpg',
        'nks_trier.jpg',
        'gdke_logo.jpg',
        'rlp-logos-MfB.jpg',
        'mffki_rlp.jpg',
        'mwg_rlp.jpg',
        'staatskanzlei_rlp.jpg',
        'SEAL_LOGO_LANG_HIGH.jpg',
        'spk_trier.jpg',
        'trier-logo.jpg',
    ]

    onMount ( () => {
        $appSettings.currentPageLink = "/about";
        $appSettings.currentPageName = "Über uns";
        $appSettings.parentPage = "/";
        window.scrollTo(0, 0);
    })
</script>

<div class="hero-img">
</div>

<section>
    <h1>Über uns</h1>
    <p><strong>Erinnerlicht</strong> ist eine Installation zum Gedenken an die jüdischen Opfer des Nationalsozialismus aus Trier und dem Umland. Jede Besucherin und jeder Besucher hat hier die Möglichkeit ein Licht zu spenden und damit das Schicksal eines Trierer Opfers zu erhellen.</p>
    <p>Konzipiert wird die Installation von einem Team aus Designer*innen und Historiker*innen aus der Hochschule und der Universität Trier, angeregt wurde sie von der <strong>AG Frieden e.V.</strong></p>
    <p>Mit <strong>Erinnerlicht</strong> möchten wir die Schicksale von Trierer Bürgerinnen und Bürgern, die als Juden verfolgt wurden, sichtbar machen und vor Ort zum ganz persönlichen Gedenken und zur Auseinandersetzung mit diesem Verbrechen anregen.</p>
</section>

<section>
    <h2>Partner</h2>
    <p>Bedanken möchten wir uns bei unseren Partnern und Sponsoren, ohne deren finanzielle und ideelle Unterstützung das Projekt nicht hätte umgesetzt werden können.</p>
    <!-- <p>In alphabetischer Reihenfolge:</p> -->
    <div class="grid">
        {#each partners as partner}
            <div class="item-container">
                <div class="item" style="background-image: url(/images/partners/{partner})"></div>
            </div>
        {/each}
    </div>
    <!-- <ul>
        <li>Beauftragter der Landesregierung für jüdisches Leben und Antisemitismusfragen Rheinland-Pfalz</li>
        <li>Herbert & Veronika Reh Stiftung</li>
        <li>Landeszentrale für politische Bildung Rheinland-Pfalz</li>
        <li>Ministerium für Familie, Frauen, Kultur und Integration Rheinland-Pfalz</li>
        <li>Ministerium für Wissenschaft und Gesundheit Rheinland-Pfalz</li>
        <li>Nikolaus-Koch-Stiftung Trier</li>
        <li>Sparkasse Trier</li>
        <li>Stadt Trier</li>
    </ul> -->
</section>

<style>
    .hero-img {
        height: 60vh;
        background-image: url("/images/bg/hero_about.jpg");
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: cover;
        margin-top: -2rem;
        margin-left: -2rem;
        margin-right: -2rem;
        position: relative;
    }

    .hero-img::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: linear-gradient(transparent 40%, #1a1a1a);
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 1rem;
        row-gap: 1rem;
    }

    @media only screen and (min-width: 25rem) {
        .grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .grid .item-container {
        background-color: white;
        border-radius: 0.6rem;
        overflow: hidden;
        padding-top: 75%;
        /* opacity: 0.5; */
        position: relative;
    }

    .item {
        position: absolute;
        top: 1.5rem;
        bottom: 1.5rem;
        left: 1.5rem;
        right: 1.5rem;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
</style>